import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { fetchKids } from "../../../Kids-list.ducks";
import { fetchOneKid } from "../../../../Kids.ducks";

// sieste actions

export const POST_SIESTE_PENDING = "POST_SIESTE_PENDING";
export const POST_SIESTE_REJECTED = "POST_SIESTE_REJECTED";
export const POST_SIESTE_FULFILLED = "POST_SIESTE_FULFILLED";

export const GET_SIESTE_PENDING = "GET_SIESTE_PENDING";
export const GET_SIESTE_REJECTED = "GET_SIESTE_REJECTED";
export const GET_SIESTE_FULFILLED = "GET_SIESTE_FULFILLED";

export const PUT_SIESTE_PENDING = "PUT_SIESTE_PENDING";
export const PUT_SIESTE_REJECTED = "PUT_SIESTE_REJECTED";
export const PUT_SIESTE_FULFILLED = "PUT_SIESTE_FULFILLED";

export const DELETE_SIESTE_PENDING = "DELETE_SIESTE_PENDING";
export const DELETE_SIESTE_REJECTED = "DELETE_SIESTE_REJECTED";
export const DELETE_SIESTE_FULFILLED = "DELETE_SIESTE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_SIESTE_PENDING:
    case GET_SIESTE_PENDING:
    case PUT_SIESTE_PENDING:
    case DELETE_SIESTE_PENDING:

      return true;
    case POST_SIESTE_REJECTED:
    case POST_SIESTE_FULFILLED:
    case GET_SIESTE_REJECTED:
    case GET_SIESTE_FULFILLED:
    case PUT_SIESTE_REJECTED:
    case PUT_SIESTE_FULFILLED:
    case DELETE_SIESTE_REJECTED:
    case DELETE_SIESTE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_SIESTE_PENDING:
    case POST_SIESTE_FULFILLED:
    case GET_SIESTE_PENDING:
    case GET_SIESTE_FULFILLED:
    case PUT_SIESTE_PENDING:
    case PUT_SIESTE_FULFILLED:
    case DELETE_SIESTE_PENDING:
    case DELETE_SIESTE_FULFILLED:
      return null;
    case POST_SIESTE_REJECTED:
    case GET_SIESTE_REJECTED:
    case PUT_SIESTE_REJECTED:
    case DELETE_SIESTE_REJECTED:

      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_SIESTE_FULFILLED:
    case GET_SIESTE_FULFILLED:
    case PUT_SIESTE_FULFILLED:
    case DELETE_SIESTE_FULFILLED:

      return _.isEmpty(payload.data) ? null : payload.data;
    case POST_SIESTE_REJECTED:
    case GET_SIESTE_REJECTED:
    case PUT_SIESTE_REJECTED:
      return null;
    case POST_SIESTE_PENDING:
    case GET_SIESTE_PENDING:
    case PUT_SIESTE_PENDING:
      return null;
    default:
      return state;
  }
};

// sieste reducer
export default combineReducers({ loading, error, data });

export const postSiesteMulti = (tok, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/siestes`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_SIESTE_FULFILLED, payload: res })
      data.idsEnfants.forEach(element => {
        dispatch(fetchOneKid(tok,element))
      });
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_SIESTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const postSiesteSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/siestes`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_SIESTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_SIESTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getSiesteEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/siestes/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_SIESTE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_SIESTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updateSiesteEvent = (tok, idEvent, data,id) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/siestes/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_SIESTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_SIESTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const deleteSiesteEvent = (tok, idEvent,id) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/siestes/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_SIESTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_SIESTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
} 